module.exports = __webpack_public_path__ + "img/open_num.41de0aac.gif";